var IconPosition;
(function (IconPosition) {
    IconPosition["left"] = "left";
    IconPosition["right"] = "right";
})(IconPosition || (IconPosition = {}));

export { IconPosition };
